module.exports = __webpack_public_path__ + "img/048-boy-21.bb8ff081.svg";